import { render, staticRenderFns } from "./news-overview.vue?vue&type=template&id=671542be&scoped=true&"
import script from "./news-overview.vue?vue&type=script&lang=ts&"
export * from "./news-overview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671542be",
  null
  
)

export default component.exports